@if (errorMessage) {
    <div class="error-message">{{ errorMessage }}</div>
}

<ddv-user-preference-labeled-row
    id="default-from-date-row"
    [label]="'Default From Date'"
    [message]="'Start date applied when a view does not have its own saved from date'"
>
    <cc-input-select
        [size]="'large'"
        [options]="fromDateOptions"
        [value]="selectedFromDateOption"
        [allowNoSelection]="true"
        (valueChange)="onFromDateChange($event)"
    >
    </cc-input-select>
</ddv-user-preference-labeled-row>

<ddv-user-preference-labeled-row
    id="default-to-date-row"
    [label]="'Default To Date'"
    [message]="'End date applied when a view does not have its own saved to date'"
>
    <cc-input-select
        [size]="'large'"
        [options]="fuzzyDateToOptions"
        [value]="selectedToDateOption"
        [allowNoSelection]="true"
        (valueChange)="onToDateChange($event)"
    >
    </cc-input-select>
</ddv-user-preference-labeled-row>

@if (isMultiClient) {
    <ddv-user-preference-labeled-row
        id="default-clients-row"
        [label]="'Default Clients'"
        [message]="'Clients applied when a view does not have its own saved client selection'"
    >
        <cc-multi-select-dropdown
            [anchorType]="'simple'"
            [anchorAlignment]="'right'"
            [size]="'large'"
            [options]="clientOptions"
            [emitOnCloseOnly]="true"
            [(selected)]="selectedClientsOptions"
            (selectedChange)="onClientsChange()"
        >
        </cc-multi-select-dropdown>
    </ddv-user-preference-labeled-row>
} @else {
    <ddv-user-preference-labeled-row
        id="default-funds-row"
        [label]="'Default Funds'"
        [message]="'Funds applied when a view does not have its own saved fund selection'"
    >
        <cc-fund-multi-select-dropdown
            [anchorType]="'simple'"
            [size]="'large'"
            [customWidth]="55"
            [anchorAlignment]="'right'"
            [emitOnCloseOnly]="true"
            [label]="''"
            [funds]="funds"
            [(selected)]="selectedFunds"
            (selectedChange)="onFundsChange()"
        >
        </cc-fund-multi-select-dropdown>
    </ddv-user-preference-labeled-row>
}

